export const DISCONNECT_ANDROID_VIDEO_URL =
  'https://ledasales-statics.s3.amazonaws.com/videos/COMO+DESCONECTAR+ANDROID+FINAL.mp4';

export const DISCONNECT_IOS_VIDEO_URL =
  'https://ledasales-statics.s3.amazonaws.com/videos/COMO+DESCONECTAR+IPHONE+FINAL.mp4';

export const DISCONNECT_ANDROID_VIDEO_POSTER_URL =
  '/images/videoCovers/disconnect-android.png';

export const DISCONNECT_IOS_VIDEO_POSTER_URL =
  '/images/videoCovers/disconnect-ios.png';
